import React from 'react';
import SearchParams from './SearchParams';

interface SearchInfoProps {
  title: string;
  candidateCount: number;
  totalFound?: number; // Total candidates in HH before relevance filtering
  filteredCount?: number; // Candidates that passed relevance filter
  isRelevanceFiltered?: boolean; // Whether relevance filter is active
  isApproximate?: boolean; // Число результатов не точное (фильтр джамперов)
  searchParams: Array<{
    id: string;
    label: string;
    value: string;
    options: Array<{ value: string; label: string }>;
    onChange: (value: string) => void;
  }>;
}

export const SearchInfo: React.FC<SearchInfoProps> = ({
  title,
  candidateCount,
  totalFound,
  filteredCount,
  isRelevanceFiltered,
  isApproximate,
  searchParams
}) => {
  const renderCandidateCount = () => {
    if (isRelevanceFiltered && totalFound !== undefined && filteredCount !== undefined) {
      return (
        <>
          Всего {totalFound.toLocaleString()}, показано {filteredCount.toLocaleString()} подходящих
        </>
      );
    }
    return (
      <>
        Найдено {candidateCount.toLocaleString()} кандидатов
        {isApproximate && <span className="text-sm text-gray-400 ml-2">(возможна погрешность)</span>}
      </>
    );
  };

  return (
    <div className="bg-white box-border content-stretch flex items-center justify-between px-[24px] py-[16px] relative rounded-tl-[12px] rounded-tr-[12px] shrink-0 w-full border-b border-gray-200">
      <div className="basis-0 content-stretch flex items-center justify-between grow min-h-px min-w-px relative shrink-0">
        <div className="flex flex-col font-inter font-medium justify-center leading-[0] not-italic relative shrink-0 text-[20px] text-gray-900 text-nowrap tracking-[-0.176px]">
          <p className="leading-[20px]">{renderCandidateCount()}</p>
        </div>

        <div className="content-stretch flex gap-[31px] items-center relative shrink-0">
          <SearchParams params={searchParams} />
        </div>
      </div>
    </div>
  );
};

export default SearchInfo;
